import type { TAccountMappingTableData } from "@/apis/odin/apiODIN";
import type {
    TAccountMappingTableDTO,
    TAssetTypeData,
} from "./TAccountMappingTableDTO";

export const convertMappingTableResponseToDTO = (
    response: TAccountMappingTableData["mappingTable"],
): TAccountMappingTableDTO[] => {
    return response.map(entry => ({
        type: entry.type,
        code: entry.code,
        account: entry.account,
        assetTypes: Object.fromEntries(
            Object.entries(entry.assetTypes).map(([key, value]) => [
                key,
                {
                    subcategory: value.subcategory ?? "",
                    includeInSummarisedDoc:
                        (
                            value as TAssetTypeData & {
                                subcategory?: string | null;
                            }
                        ).includeInSummarisedDoc ?? true,
                } satisfies TAssetTypeData,
            ]),
        ),
        mappedAccountCode: entry.mappedAccountCode ?? null,
        mappedSection: entry.mappedSection ?? null,
        mappedSubcategory: entry.mappedSubcategory ?? null,
        originalMappedAccountCode: entry.originalMappedAccountCode ?? null,
    }));
};
